import React from 'react';
import {
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownHeader,
    CDropdownItem,
    CDropdownDivider,
    CAvatar,
    CImage,
    CRow,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { cilPlus, cilCheckCircle, cilChevronBottom } from '@coreui/icons';
import { AccountsItems } from '../models/Accounts';
import { useStore } from '../contexts/StoreContext';

interface Store {
    id: string;
    name: string;
    logoUrl?: string;
    isOpen: boolean;
    city?: string;
}

interface StoreSelectorProps {
    stores: AccountsItems[];
    activeStoreId: string;
    onSelectStore: (storeId: string) => void;
    onCreateNewStore: () => void;
    onViewProfile: () => void;
}

export const StoreSelectorDropdown: React.FC<StoreSelectorProps> = ({
    stores,
    activeStoreId,
    onSelectStore,
    onCreateNewStore,
    onViewProfile,
}) => {
    const activeStore = stores.find((s) => String(s.id) === String(activeStoreId)) || stores[0];
    return (
        <CDropdown className="store-selector-dropdown" alignment="end">
            {/* Botón de la barra superior: avatar cuadrado + nombre + estado */}
            <CDropdownToggle caret={false} color="ghost" className="md-menu-row md-store-toggle">
                <span className="md-avatar">
                    {activeStore?.logo ? <img src={activeStore.logo} alt="" /> : activeStore?.name?.charAt(0) || 'T'}
                </span>
                <span className="md-menu-row-text">
                    {activeStore?.name || 'Seleccionar Tienda'}
                    <span className="md-menu-row-sub">
                        {activeStore?.verified ? (
                            <span className="text-success">● Abierto</span>
                        ) : (
                            <span>● Cerrado</span>
                        )}
                    </span>
                </span>
                <CIcon icon={cilChevronBottom} size="sm" className="md-menu-row-dots" />
            </CDropdownToggle>

            <CDropdownMenu className="mt-1" style={{ minWidth: '240px' }}>
                <CDropdownHeader>
                    Tienda Activa
                </CDropdownHeader>

                {/* TIENDA SELECCIONADA */}
                {activeStore && (
                    <CDropdownItem
                        onClick={onViewProfile}
                        className="d-flex align-items-center justify-content-between"
                    >
                        <div className="d-flex align-items-center cursor-pointer">
                            <CAvatar src={activeStore.logo} size="sm" className="me-2 border border-secondary-subtle" />
                            <CRow>
                                <span className="fw-semibold text-body">{activeStore.name}</span>
                                <small>Ver perfil</small>
                            </CRow>
                        </div>
                        <CIcon icon={cilCheckCircle} className="text-body ms-2" />
                    </CDropdownItem>
                )}

                {/* {activeStore && (
                    <CDropdownItem
                        onClick={onViewProfile}
                        className="d-flex align-items-center py-2 px-3 text-body cursor-pointer"
                    >
                        <CIcon icon={cilHome} className="me-2 text-body-secondary" />
                        Ver perfil de la tienda
                    </CDropdownItem>
                )} */}

                <CDropdownDivider />

                <CDropdownHeader>
                    Mis Otras Tiendas ({stores.length})
                </CDropdownHeader>

                {/* LISTADO DE OTRAS TIENDAS DEL USUARIO */}
                {stores
                    .filter((s) => String(s.id) !== String(activeStoreId))
                    .map((store) => (
                        <CDropdownItem
                            key={store.id}
                            onClick={() => onSelectStore(store.id.toString())}
                            className="d-flex align-items-center py-2 px-3 cursor-pointer text-body"
                        >
                            {/* <CIcon icon={cilHome} className="me-2 text-body-secondary" /> */}
                            <CAvatar src={store.logo} size="sm" className="me-2 border border-secondary-subtle" />

                            <div className="d-flex flex-column ms-1">
                                <span className="fw-medium text-body">{store.name}</span>
                                {store.plans_name && <small className="text-body-secondary" style={{ fontSize: '0.7rem' }}>{store.plans_name}</small>}
                            </div>
                        </CDropdownItem>
                    ))}

                <CDropdownDivider />

                {/* OPCIÓN PARA CREAR NUEVA TIENDA */}
                <CDropdownItem
                    onClick={onCreateNewStore}
                    className="d-flex align-items-center py-2 px-3 text-body fw-semibold cursor-pointer"
                >
                    <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-2 bg-body-tertiary text-body border border-secondary-subtle"
                        style={{ width: '24px', height: '24px' }}
                    >
                        <CIcon icon={cilPlus} size="sm" />
                    </div>
                    Crear Nueva Tienda
                </CDropdownItem>
            </CDropdownMenu>
        </CDropdown>
    );
};

export default StoreSelectorDropdown;